import type { ChainBalance, ChainBasicInfo, TokenBalance, TokenBasicInfo } from '@/lib/types/account'

interface TokenSelection {
  chainId: string
  tokenAddress: string
}

export type ChainBalanceWithToken = ChainBalance & { tokenIcon: string, tokenSymbol: string }
/**
 * Filter tokens based on search term
 * @param tokenList List of tokens to filter
 * @param searchTerm Search term to filter tokens
 * @returns Filtered tokens based on search term
 */
export function filteredTokens(tokenList: TokenBasicInfo[], searchTerm = ''): TokenBasicInfo[] {
  if (!searchTerm) {
    return tokenList
  }

  return tokenList.filter(token =>
    token.name.toLowerCase().includes(searchTerm.toLowerCase()),
  )
}

/**
 * 从fundBalances中根据chainId获取第一个匹配的token作为selectedToken
 * @param fundBalances 资金余额列表
 * @param chainId 链ID
 * @returns 第一个匹配的token信息，包含chainId和tokenAddress
 */
export function getFirstTokenByChainId(
  fundBalances: TokenBalance[],
  // chainId: string,
  // tokenAddress?: string,
): TokenSelection | null {
  // 遍历所有token余额
  return fundBalances?.[0]?.chainBalances?.[0] || null
}
export function getTokenByTokenSelection(
  fundBalances: TokenBalance[],
  tokenSelection: TokenSelection | null,
): ChainBalanceWithToken | null {
  if (!tokenSelection) {
    return null
  }
  // 遍历所有token余额
  for (const tokenBalance of fundBalances) {
    // 在当前token的链余额中查找匹配的chainId
    const matchingChain = tokenBalance.chainBalances.find(
      chain => chain.chainId === tokenSelection.chainId && (tokenSelection.tokenAddress ? chain.tokenAddress === tokenSelection.tokenAddress : true),
    )

    // 如果找到匹配的链，返回对应的token信息
    if (matchingChain) {
      return {

        ...matchingChain,
        tokenIcon: tokenBalance.tokenIcon, // 使用tokenBalance的icon作为tokenIcon
        tokenSymbol: tokenBalance.tokenSymbol, // 使用tokenBalance的tokenSymbol

      }
    }
  }

  // 如果没有找到匹配的token，返回null
  return null
}
export function getTokenByTokenSymbolAndChainId(
  fundBalances: TokenBalance[],
  tokenSymbol?: string,
  chainId?: string,
): ChainBalanceWithToken | null {
  if (!tokenSymbol || !chainId) {
    return null
  }
  // 遍历所有token余额
  for (const tokenBalance of fundBalances) {
    // 在当前token的链余额中查找匹配的chainId
    const matchingChain = tokenBalance.chainBalances.find(
      chain => chain.chainId === chainId && (tokenSymbol === tokenBalance.tokenSymbol),
    )

    // 如果找到匹配的链，返回对应的token信息
    if (matchingChain) {
      return {

        ...matchingChain,
        tokenIcon: tokenBalance.tokenIcon, // 使用tokenBalance的icon作为tokenIcon
        tokenSymbol: tokenBalance.tokenSymbol, // 使用tokenBalance的tokenSymbol

      }
    }
  }

  // 如果没有找到匹配的token，返回null
  return null
}
export function getDecimalPlaces(value: string): number {
  if (!value || typeof value !== 'string') {
    return 0
  }

  // Remove any whitespace
  const trimmed = value.trim()

  // Check if the string contains a decimal point
  const decimalIndex = trimmed.indexOf('.')
  if (decimalIndex === -1) {
    return 0
  }

  // Get the decimal part
  const decimalPart = trimmed.slice(decimalIndex + 1)

  // If ends with '.0', return 0
  if (decimalPart === '0') {
    return 0
  }

  // Remove trailing zeros and return the length
  const withoutTrailingZeros = decimalPart.replace(/0+$/, '')
  return withoutTrailingZeros.length
}
export function getBasicTokenInfoByChainIdAndAddress(
  basicTokenList: ChainBasicInfo[],
  chainId: string,
  tokenAddress?: string,
): TokenBasicInfo | null {
  if (!basicTokenList) {
    return null
  }
  // 遍历所有token余额
  for (const basicChainInfo of basicTokenList) {
    // 在当前token的链余额中查找匹配的chainId
    const matchedToken = basicChainInfo.tokenList.find(
      token => basicChainInfo.chainId === chainId && (tokenAddress ? token.address.toLowerCase() === tokenAddress.toLowerCase() : true),
    )

    // 如果找到匹配的链，返回对应的token信息
    if (matchedToken) {
      return matchedToken
    }
  }

  // 如果没有找到匹配的token，返回null
  return null
}
